<template>
    <svg :width="svgWidth" :height="svgHeight" viewBox="0 0 10 8" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M0.75 4L3.58 6.83L9.25 1.17"
        :stroke="color"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"/>
    </svg>
  </template>
  <script>
  export default {
    props: {
      width: {
        type: String,
        default: '10',
      },
      height: {
        type: String,
        default: '8',
      },
      color: {
        type: String,
        default: '#34C759',
      },
    },
    data() {
      return {
        isHover: false,
      };
    },
    computed: {
      svgWidth() {
        return this.width;
      },
      svgHeight() {
        return this.height;
      },
    },
  };
  </script>
